export default __webpack_public_path__ + "static/media/flourishing_yellow_petal.3e9fb60d.svg";